import { useCancellationModal } from "./CancellationModal";
import { LandingPage } from "./LandingPage";

export const EmailHub = {
  LandingPage,
  useCancellationModal,
};
